import {
  phoneAllowedRegexPattern,
  phoneOnChangeRegexPattern,
  phoneOnPasteRegexPattern,
} from './regexPatterns';

export const phoneOnPasteSanitizer = (event: React.ClipboardEvent) => {
  event?.clipboardData?.items[0].getAsString((phoneEntered: string) => {
    if (phoneEntered) {
      const sanitizedAllowedPattern = phoneEntered.replace(
        phoneOnPasteRegexPattern,
        ''
      );
      return sanitizedAllowedPattern;
    }
  });
};

export const allowedPhonePattern = (event: React.KeyboardEvent) => {
  const regex = phoneAllowedRegexPattern;
  if (!regex.test(event.key)) {
    event.preventDefault();
    return false;
  }
};

export const phoneInputChange = (event: React.FormEvent) => {
  const eventValue = (event.target as HTMLInputElement).value;
  const sanitizedAllowedPattern = eventValue.replace(
    phoneOnChangeRegexPattern,
    '+'
  );
  return sanitizedAllowedPattern;
};
